import {
  GET_CALL_SUMMARY,
  GET_CALL_SUMMARY_SUCCESS,
  GET_CALL_SUMMARY_ERROR,

} from "./actionTypes"

const INIT_STATE = {
  call_summary: [],
  error: null,
  call_summary_loading: false,
}
const CallSummary = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CALL_SUMMARY:
      return {
        ...state,
        call_summary_loading: true,
        error: null,
      }

    case GET_CALL_SUMMARY_SUCCESS:
      return {
        ...state,
        call_summary_loading: false,
        call_summary: action.payload,
        error: null,
      }


    case GET_CALL_SUMMARY_ERROR:
      return {
        ...state,
        call_summary_loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default CallSummary
